import { render, staticRenderFns } from "./ActivityBarcelo01Catalog.vue?vue&type=template&id=6d3d7d59&scoped=true&"
import script from "./ActivityBarcelo01Catalog.vue?vue&type=script&lang=js&"
export * from "./ActivityBarcelo01Catalog.vue?vue&type=script&lang=js&"
import style0 from "./ActivityBarcelo01Catalog.vue?vue&type=style&index=0&id=6d3d7d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3d7d59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSpacer,VToolbar,VToolbarTitle})
